// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"560":"0c25ac6b","678":"d2d01788","756":"312bb854","788":"ac32ac76","799":"783d1871","956":"4ef18565"}[chunkId] + ".js";
};